import { Injectable } from '@angular/core';
import { IIDolRispostaSollecitoStore } from './iidOlRispostaSollecito.store';
import { IID_OL_RISPOSTA_SOLLECITO } from '@common/interfaces/interfaceData';
import { ActionService } from '../action/action.service';
import { Topics } from '@common/interfaces/topics';
import { IIDolRispostaSollecitoQuery } from './iidOlRispostaSollecito.query'
import { CrudService } from '../crudService';
import { ProjectEntityStoreStrategy } from '../updateStoreStrategies';
import { InterfaceDataService } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';
@Injectable({
  providedIn: 'root'
})
@InterfaceDataService(InterfaceName.RISPOSTA_SOLLECITO)
export class IIDolRispostaSollecitoService extends CrudService<IID_OL_RISPOSTA_SOLLECITO, IIDolRispostaSollecitoStore, IIDolRispostaSollecitoQuery> {
  constructor(
    protected store: IIDolRispostaSollecitoStore,
    public query: IIDolRispostaSollecitoQuery,
    protected actionService: ActionService,
    protected updateStrategy: ProjectEntityStoreStrategy) {
    super(
      Topics.IID_OL_RISPOSTA_SOLLECITO,
      store,
      query,
      actionService,
      updateStrategy,
    );
  }

}
